import { useSelector } from 'react-redux';

import { selectors } from '../store/dux/auth-dux';

export function useCurrentUser() {
  return useSelector(selectors.currentUser);
}
